// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3Ymnq","label":"Labeled_label__2r_rk","divider":"Labeled_divider__VLSSR"};